export default __webpack_public_path__ + "static/media/pic9.12f1731b.jpg";